import React, { useEffect, useState } from 'react'
import { setupMediaHeartbeat } from './adobeAnalytics';

const useAdobeAnalyticsSdk = () => {

    const [mediaScriptLoaded,setMediaScriptLoaded] = useState(window.adobeMediaScriptLoaded);

    function loadAdobeAnalytics() {
        return new Promise((res, rej) => {
            const appMeasurementScript = window?.app_data?.appcmsMain?.analytics?.adobeConfig?.appMeasurement
            const script = document.createElement("script");
            script.src = appMeasurementScript; //app measurement URL
            script.async = true;
            document.body.appendChild(script);
            script.onload = () => {res()}
            script.onerror = (e) => { rej(`Error while loading script ${src} : ${e}`) }
        })
    }


    function loadMediaSdk() {
        window.adobeConfigurationLoaded = false;
        window.adobeMediaScriptLoaded = false;
        return new Promise((res, rej) => {
            const mediaSdkScript = window?.app_data?.appcmsMain?.analytics?.adobeConfig?.mediaSdk
            const script = document.createElement("script");
            script.src = mediaSdkScript;
            script.async = true;
            document.head.appendChild(script);
            script.onload = () => {
                res()
                window.adobeMediaScriptLoaded = true;
                setMediaScriptLoaded(true)
            }
            script.onerror = (e) => { rej(`Error while loading script ${src} : ${e}`) }
        })
    }
    useEffect(() => {
        loadAdobeAnalytics().then(() => {
            loadMediaSdk()
        })
    }, [])
    useEffect(() => {
        if (window.adobeMediaScriptLoaded && !window.adobeConfigurationLoaded) {
            const Media = window?.ADB?.Media;
            const MediaConfig = window?.ADB?.MediaConfig;
            if (Media && MediaConfig) {
                setupMediaHeartbeat(Media, MediaConfig);
            } else {
                console.error("Media SDK or MediaConfig is not available.");
            }
        }
    }, [mediaScriptLoaded])
}

export default useAdobeAnalyticsSdk